import {EquityTicketService} from "./EquityTicketService";
import {EquityTicketDialogService} from "./dialog/EquityTicketDialogService";

export default function() {
    return angular.module("tfApp.portfolio.ticket.equity", [])
                  .service(EquityTicketService.id, EquityTicketService)
                  .service(EquityTicketDialogService.id, EquityTicketDialogService)
                  .name;
}
